<script lang="ts">
  export let text: string;
</script>

<span
  class="text-[#344054] text-lg/[1.5rem] font-medium text-center"
  data-testid="welcome-message"
>
  {text}
</span>
